import { Grid, Card, CardHeader, CardContent, Typography } from '@mui/material';

import { customersApiKeyStore } from '../../../api/customers-api-key-store';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormAutoCompleteMultiSelectDynamic } from '../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useFormContext } from 'react-hook-form';
import { useSaveData } from '../../../hooks/useSaveData';
import { LoadingIndicator } from '../../../components/loading-indicator.component';

export interface Option {
  value: any;
  label: string;
  isDefault: boolean;
}

interface CustomerInfoFormProps {
  isEdit?: boolean;
  customerId?: number | undefined;
}

const isDUXEnabled = process.env.REACT_APP_DUX_FLAG === 'true';

export const CustomerInfoForm = ({ isEdit, customerId }: CustomerInfoFormProps) => {
  const isSyncWithDuxPermission = useAuthorize([UserPermissionName?.SYNC_WITH_DUX]);
  const { setValue } = useFormContext();
  const {
    isLoading,
    mutateAsync,
    data: duxSyncStatusChangeData,
  } = useSaveData<any>(customersApiKeyStore.duxSyncStatusChange());

  const handleChangeSyncWithDux = (e: any) => {
    setValue('syncWithDux', !e.target.checked);
    mutateAsync({
      data: {
        projectID: 0,
        officeID: 0,
        customerID: !customerId ? 0 : customerId,
        syncWithDux: e.target.checked,
      },
    }).then(() => {
      setValue('syncWithDux', !e.target.checked);
    });
  };

  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary">
            CUSTOMER INFO
          </Typography>
        }
      ></CardHeader>
      <CardContent className="formContainer">
        <Grid container spacing={2}>
          <Grid item lg={6} sm={6} xl={6} xs={6}>
            <Grid container spacing={2}>
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormInput
                  name="customerName"
                  label="Customer Name"
                  validationQueryRoute={(value: any) => value && customersApiKeyStore.validateCustomer(value)}
                  autoFocus
                />
              </Grid>
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormAutoCompleteMultiSelectDynamic
                  className="requiredField"
                  name="customerTypes"
                  label="Customer Type"
                  getQueryKeyConfig={() => customersApiKeyStore.getCustomerTypes()}
                  optionsLabelKey="customerType"
                  optionsValueKey="customerTypeID"
                />
              </Grid>
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormInput
                  name="customerCode"
                  label={!isEdit ? 'Customer Code' : 'Code will generate while saving the data'}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={6} sm={6} xl={6} xs={6}>
            <Grid container spacing={2}>
              <Grid item lg={12} sm={12} xl={12} xs={12}>
                <FormInput name="description" label="Description" multiline size={3.5} />
              </Grid>
              {isDUXEnabled && isSyncWithDuxPermission && (
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                  {<LoadingIndicator isLoading={isLoading} />}
                  <FormCheckbox
                    label="Sync With DUX"
                    name="syncWithDux"
                    onChange={!isEdit ? handleChangeSyncWithDux : undefined}
                  />
                </Grid>
              )}
            </Grid>
            <Grid />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
